module.exports = {

    title: '深度云海',

    /**
     * @type {boolean} true | false
     * @description Whether fix the header
     */
    fixedHeader: false,

    /**
     * @type {boolean} true | false
     * @description Whether show the logo in sidebar
     */
    sidebarLogo: false,
    "typescript.validate.enable": false,
    "javascript.validate.enable": false,
}
